<template>
	<div class="popup" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title popup__title--back" @click="$emit('close')" >Редактирование поставщика «{{ supplier.companyName }}»</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="info-list">
					<div class="info-list__item">
						<div class="info-item">
							<div class="info-item__el info-item__el--3">
								<span class="info-item__label">Статус</span>
								<span class="info-item__status">
									<span class="status" :data-status="supplier.status?.name">{{ supplier.status?.name }}</span>
								</span>
							</div>
						</div>
					</div>
					<div class="info-list__item">
						<div class="info-list__title page-subtitle">Контактное лицо</div>
						<div class="info-item">
							<div class="info-item__el">
								<InputText label="Имя *" placeholder="Введите имя" v-model="formData.name" :errors="v$.formData.name.$errors"/>
							</div>
							<div class="info-item__el">
								<InputText label="Фамилия *" placeholder="Введите фамилию"  v-model="formData.lastName" :errors="v$.formData.lastName.$errors"/>
							</div>
							<div class="info-item__el">
								<InputText label="Отчество *" placeholder="Введите отчество"  v-model="formData.secondName" :errors="v$.formData.secondName.$errors"/>
							</div>
							<div class="info-item__el">
								<InputText label="E-mail *" placeholder="Введите E-mail" v-model="formData.email" :errors="v$.formData.email.$errors"/>
							</div>
							<div class="info-item__el info-item__el--2">
								<input-select label="Город" :errors="v$.formData.city.$errors">
									<template #select>
										<Multiselect
											:can-clear="true"
											:canDeselect="false"
											:searchable="true"
											:placeholder="supplier.city"
											no-results-text="Город не найден"
											ref="multiselect"
											:label="'name'"
											:value-prop="'name'"
											v-model="formData.city"
											:filter-results="false"
											:min-chars="2"
											:resolve-on-load="true"
											:delay="2000"
											:no-options-text="'Города не найдены'"
											:noOptionsText="'Введите название города'"
											:options="async function(query) {
												return await fetchCities(query)
											}"/>
									</template>
								</input-select>
							</div>
							<div class="info-item__el info-item__el--3">
								<InputMultiplyPhone v-model="formData.phones" :phones="supplier.phones"/>
							</div>
						</div>
					</div>
					<div class="info-list__item">
						<div class="info-list__title page-subtitle">Организация</div>
						<div class="info-item">
							<div class="info-item__el">
								<input-select :label="'Тип регистрации*'" :errors="v$.formData.legalForm.$errors">
									<template #select>
										<Multiselect
											v-model="formData.legalForm"
											:can-clear="false"
											:canDeselect="false"
											:placeholder="'Выберите тип'"
											ref="multiselectLegal"
											:label="'name'"
											:value-prop="'id'"
											:options="legal"
											/>
									</template>
								</input-select>
							</div>
							<div class="info-item__el info-item__el--2">
								<InputText label="Наименование организации *" placeholder="Введите наименование организации" v-model="formData.companyName" :errors="v$.formData.companyName.$errors"/>
							</div>							
							<div class="info-item__el">
								<InputText label="ИНН(Иной налоговый идентификатор для импорта) *" :placeholder="'Введите ИНН'" :number="30" v-model="formData.inn" :errors="v$.formData.inn.$errors"/>
							</div>
							<div class="info-item__el">
								<InputText label="ОГРН *" placeholder="Введите ОГРН" :number="15" v-model="formData.ogrn" :errors="v$.formData.ogrn.$errors"/>
							</div>
							<div class="info-item__el">
								<InputText label="КПП *" placeholder="Введите КПП" :number="9" v-model="formData.kpp" :errors="v$.formData.kpp.$errors"/>
							</div>	
							<div class="info-item__el ">
								<InputText label="Факс" placeholder="Введите Факс" v-model="formData.fax"/>
							</div>						
							<div class="info-item__el info-item__el--2">
								<InputText label="Название головного офиса" placeholder="Введите название головного офиса" v-model="formData.mainOfficeName"/>
							</div>					

							<div class="info-item__el info-item__el--3">
								<InputText label="Юридический адрес *" placeholder="Введите юридический адрес" v-model="formData.legalAddress" :errors="v$.formData.legalAddress.$errors"/>
							</div>							
							<div class="info-item__el info-item__el--3">
								<div class="line-btn">
									<InputText label="Фактический адрес *"  placeholder="Введите фактический адрес" v-model="formData.actualAddress" :errors="v$.formData.actualAddress.$errors"/>
									<button v-if="formData.legalAddress && formData.actualAddress !== formData.legalAddress" class="btn btn--color" @click="formData.actualAddress = formData.legalAddress">Совпадает с юридическим</button>
								</div>
							</div>
							<div class="info-item__el">
								<InputChoice label="Работает с НДС" v-model="formData.workWithVat" />
							</div>
							<div class="info-item__el">
								<InputChoice label="Производитель" v-model="formData.isManufacturer" />
							</div>
							<div class="info-item__el">
								<InputChoice label="Работает по EDI" v-model="formData.workWithEdi" />
							</div>
							<div class="info-item__el">
								<input-select label="Продукция подконтрольна *" :errors="v$.formData.productControl.$errors">
									<template #select>
										<Multiselect
											v-model="formData.productControl"
											:can-clear="false"
											:canDeselect="false"
											:placeholder="'Выберите организацию'"
											ref="multiselectProductControl"
											:label="'name'"
											:value-prop="'id'"
											:mode="'tags'"
											:options="productControl"
											/>
									</template>
								</input-select>
							</div>
							<template v-if="formData.workWithEdi">
								<div class="info-item__el">
									<input-select :label="'EDI *'" :errors="v$.formData.edi.$errors">
										<template #select>
											<Multiselect
												v-model="formData.edi"
												:can-clear="false"
												:canDeselect="false"
												:placeholder="'Выберите EDI'"
												ref="multiselectEdi"
												:label="'name'"
												:value-prop="'id'"
												:options="edi"
												/>
										</template>
									</input-select>
								</div>
							</template>
						</div>
					</div>
				<div class="info-textarea">
					<div class="page-subtitle">Расскажите о себе</div>
					<InputTextarea :placeholder="'Дополнительная информация'" v-model="formData.extraInfo"/>
				</div>
					<div class="info-list__item">
						<div class="info-list__title page-subtitle">Документы</div>
						<UploadDocs v-model="formData.documents"  :docsList="this.supplier?.documents" dark/>
					</div>
					
					<div class="info-list__item">
						<ProductCategories v-if="checkUserRole('administrator') || checkUserRole('manager')"
							:title="'Разрешить товарные группы'"
							:supplierId="supplier.id"
							:checkedProductGroups="supplier.productGroups"
							v-model="formData.productGroups"/>

						<SupplierProductCategories v-else
							:title="'Разрешить товарные группы'"
							:supplierId="supplier.id"
							:checkedProductGroups="supplier.productGroups"
							v-model="formData.productGroups"/>
					</div>
					<div class="info-list__item">
						<SupplierProductCategories
							:title="'Запретить товары'"
							:supplierId="supplier.id"
							:checkedProductGroups="supplier.blacklistProducts"
							:prefix="'b'"
							:showProducts="true"
							:tagsBlock="true"
							v-model="formData.blacklistProducts"/>
					</div>

				</div>
			</div>
			<hr>
			<div class="popup__btns">
				<button class="btn btn--color" @click.prevent="sendForm">Сохранить</button>
			</div>
		</div>
	</div>
</template>

<script>
import { inject } from 'vue'
import InputText from "@/components/base/utils/formElements/InputText.vue";
import InputTextarea from "@/components/base/utils/formElements/InputTextarea.vue";
import InputMultiplyPhone from "@/components/base/utils/formElements/InputMultiplyPhone.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import UploadDocs from "@/components/base/utils/UploadDocs.vue";
import SupplierProductCategories from "@/components/sections/Suppliers/SupplierProductCategories.vue";
import ProductCategories from "@/components/blocks/ProductCategories";
import {useToast} from "vue-toastification";
import useVuelidate from "@vuelidate/core";
import {required, helpers, email, minLength, maxLength} from '@vuelidate/validators'
const {withMessage} = helpers
import objectToFormData from "@/utils/ObjectToFormData";
import Fetch from "@/utils/Fetch";
import { mapGetters } from 'vuex';
import InputChoice from "@/components/base/utils/formElements/InputChoice.vue";

const checkLength  = (min,max) => (value) => {
	if(value.length === min || value.length === max){
		return true
	}
	return false
}


export default {
	name: "EditSupplierPopup",
	components: {
		ProductCategories,
		InputText,
		SupplierProductCategories, 
		Multiselect, InputSelect,
		InputTextarea,
		InputMultiplyPhone,
		UploadDocs,
		InputChoice},
	emits: ["refreshList", "close"],
	props: {
		supplier: {
			type: Object,
			default: ()=> {}
		},
		backBtn: {
			type: Boolean,
			default: false
		},
		
	},
	setup() {
		const legal = inject('legal')
		const edi = inject('edi')
		const productControl = inject('productControl')
		return {
			legal,
			edi,
			productControl,
			v$: useVuelidate()
		}
	},
	data() {
		return {
			toast: useToast(),
			formData: {
				name: this.supplier.name || '',
				lastName: this.supplier.lastName || '',
				secondName: this.supplier.secondName || '',
				email: this.supplier.email || '',
				phones: this.supplier.phones || '',
				city:  this.supplier.city || '',
				legalForm: this.supplier.legalForm?.id || '',
				inn: this.supplier.inn  || '',
				ogrn: this.supplier.ogrn  || '',
				kpp: this.supplier.kpp  || '',
				fax: this.supplier.fax  || '',
				edi: this.supplier.edi?.id || '',
				productControl: this.supplier?.productControl.map(item => item.id) || [],
				workWithEdi: this.supplier.workWithEdi || false,
				workWithVat: this.supplier.workWithVat || false,
				isManufacturer: this.supplier.isManufacturer || false,
				companyName: this.supplier.companyName || '',
				mainOfficeName: this.supplier.mainOfficeName || '',
				actualAddress: this.supplier.actualAddress || '',
				legalAddress: this.supplier.legalAddress || '',
				extraInfo: this.supplier.extraInfo || '',	
				documents: 	this.supplier.documents || '',		
				productGroups: [],
				blacklistProducts: [],
			},
			selectedCity: this.supplier.id || null,
		}
	},
	methods: {	
		async sendForm() {
			const validated = await this.v$.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				return
			}
			const body = objectToFormData({
				id: this.supplier.id,
				name: this.formData.name,
				lastName: this.formData.lastName,
				secondName: this.formData.secondName,
				email: this.formData.email,
				phones: this.formData.phones,
				city: this.formData.city,
				legalForm: this.formData.legalForm,
				workWithEdi: this.formData.workWithEdi,
				isManufacturer: this.formData.isManufacturer,
				workWithVat: this.formData.workWithVat,
				productControl: this.formData.productControl,
				mainOfficeName: this.formData.mainOfficeName,
				edi: this.formData.workWithEdi ? this.formData.edi : null,
				fax: this.formData.fax,
				inn: this.formData.inn,
				ogrn: this.formData.ogrn,
				kpp: this.formData.kpp,
				companyName: this.formData.companyName,
				legalAddress: this.formData.legalAddress,
				actualAddress: this.formData.actualAddress,
				extraInfo: this.formData.extraInfo,
				productGroups: this.formData.productGroups,
				documents: this.formData.documents,
				blacklistProducts: this.formData.blacklistProducts,
			})

			let response = await Fetch(`suppliers/update/`, {
				method: 'POST',
				body
			})

			if(response.success) {
				this.toast.success('Поставщик успешно отредактирован');
				this.$emit('close')
				this.$emit('refreshList')
			} else {
				this.toast.error(response.message);
			}
		},
		async fetchCities(query) {
			if(!query) return 
			const response = await Fetch(`info/cities/search/?query=${query}`, {
				method: 'GET',
			});
			return response.data
		}
	},
	computed: {
		...mapGetters({
			checkUserRole: 'user/checkUserRole',
		})
	},
	validations() {
		return {
			formData: {
				name: {
					required: withMessage("Заполните имя", required),
					minLength: withMessage("В имени должно быть минимум 2 буквы", minLength(2)),
					maxLength: withMessage("В имени должно быть максимум 30 букв", maxLength(30)),
				},
				lastName: {
					required: withMessage("Заполните фамилию", required),
					minLength: withMessage("В фамилии должно быть минимум 2 буквы", minLength(2)),
					maxLength: withMessage("В фамилии должно быть максимум 30 букв", maxLength(30)),
				},
				secondName: {
					required: withMessage("Заполните отчество", required),
					minLength: withMessage("В отчестве должно быть минимум 2 буквы", minLength(2)),
					maxLength: withMessage("В отчестве должно быть максимум 30 букв", maxLength(30)),
				},
				email: {
					required: withMessage('Заполните E-mail', required),
					email: withMessage('Неверный формат электронной почты', email),
				},
				city: {
					required: withMessage("Выберите город", required),
				},
				legalForm: {
					required: withMessage("Выберите тип", required),
				},
				inn: {
					required: withMessage("Заполните ИНН", required),
				},
				ogrn: {
					checkLength: withMessage('В ОГРН должно быть 13 или 15 цифр', checkLength(13,15))
				},
				edi: {
					required: this.formData.workWithEdi ? withMessage("Заполните EDI", required) : true,
				},
				productControl: {
					required: withMessage("Заполните кому подконтрольна", required),
				},
				companyName: {
					required: withMessage("Заполните наименование организации", required),
					minLength: withMessage("В наименовании должно быть минимум 3 букв", minLength(3)),
				},
				legalAddress: {
					required: withMessage("Заполните адрес", required),
					minLength: withMessage("В адресе должно быть минимум 5 букв", minLength(5)),
				},
				actualAddress: {
					required: withMessage("Заполните адрес", required),
					minLength: withMessage("В адресе должно быть минимум 5 букв", minLength(5)),
				},
				kpp: {
					checkLength: withMessage('В кпп должно быть 9 цифр', checkLength(9,9))				
				}
			}
		}
	},
}
</script>
